"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.form.title.edit': 'Modifica Settore',
    'branch.form.title.add': 'Aggiungi Settore',
    'branch.form.back': 'Indietro',
    'branch.form.name.label': 'Nome',
    'branch.form.name.placeholder': 'Nome del settore',
    'branch.form.color.label': 'Colore',
    'branch.form.color.placeholder': 'Colore del settore',
    'branch.form.description.label': 'Descrizione',
    'branch.form.description.placeholder': 'Descrizione',
    'branch.form.submit.update': 'Aggiorna Settore',
    'branch.form.submit.create': 'Crea Settore',
};
